import SoldOut from '@/assets/decisionMakingGame/sold-out.svg';

export const slide39 = {
  on: {
    CLICK_NEXT: 'slide44',
  },
  meta: {
    id: 'slide39',
    section: '65f6bd2b260611eab1b11adb',
    event: 'CLICK_NEXT',
    display: {
      backgroundColor: '',
      backgroundGradient:
        'linear-gradient(162.24deg, #FF9900 3.25%, #FEBD59 51.89%, #FFCD14 102.77%)',
      backgroundImage: '',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-no-repeat',
      backgroundOpacity: 1,
      backgroundVideo: '',
      transition: 'slide',
      transitionSpeed: 'default',
      backgroundTransition: 'fade',
    },
    content: [
      {
        name: 'image',
        type: 'content',
        content: {
          src: 'https://res.cloudinary.com/dcodkxpej/image/upload/v1710669079/Decision%20making%20game/girls/Group_36644_zoltji.svg',
          width: '276px',
          height: '276px',
        },
      },
      {
        name: 'base_text',
        type: 'content',
        content: {
          color: 'text-[#F6652A]',
          title: 'כל הארטיקים נמכרו.',
          footer: 'איזה מזל שהקשבתי לו והעברתי\n את הדוכן. הוא מה זה צדק!  ',
          colorFooter: 'text-white',
        },
      },
    ],
    elements: [
      {
        src: SoldOut,
        x: '45%',
        y: '-415px',
        zIndex: 100,
      },
    ],
  },
};
export default slide39;
